<div class="overflow-hidden rounded-xl border border-cp-line-strong bg-cp-surface text-[13px] shadow-cp" aria-hidden="true">
  <div class="grid grid-cols-1 md:grid-cols-[208px_minmax(0,1fr)] lg:grid-cols-[208px_minmax(0,1fr)_300px]">
    <!-- Sidebar -->
    <div class="hidden border-r border-cp-line p-3 md:block">
      <div class="flex items-center gap-2 px-2 py-1.5">
        <img src="assets/img/creditpathlogo.webp" alt="" width="16" height="16" class="h-4 w-4" />
        <span class="font-[510] text-cp-ink">creditpath.io</span>
      </div>
      <ul class="mt-4 space-y-0.5">
        @for (item of sidebar; track item.label) {
          <li [class]="'flex items-center gap-2.5 rounded-md px-2 py-1.5 ' + (item.active ? 'bg-cp-fill text-cp-ink' : 'text-cp-muted')">
            <ng-icon [name]="item.icon" size="15" />
            <span class="truncate">{{ item.label }}</span>
          </li>
        }
      </ul>
      <p class="mt-6 px-2 text-[12px] text-cp-subtle">Loan Type</p>
      <ul class="mt-1.5 space-y-0.5 text-cp-muted">
        <li class="truncate px-2 py-1">Residential Real Estate</li>
        <li class="truncate px-2 py-1">Commercial Real Estate</li>
        <li class="truncate px-2 py-1">Securities Backed LOC</li>
      </ul>
    </div>

    <!-- Request table -->
    <div class="min-w-0">
      <div class="flex items-center justify-between gap-3 border-b border-cp-line px-4 py-3">
        <div class="min-w-0">
          <p class="font-[510] text-cp-ink">Advisor Portal</p>
          <p class="truncate text-[12px] text-cp-subtle">Manage and track your term requests</p>
        </div>
        <span class="inline-flex shrink-0 items-center rounded-md bg-cp-btn px-2.5 py-1 font-[510] text-cp-btn-fg">
          Request Terms
        </span>
      </div>
      <div class="flex items-center gap-4 border-b border-cp-line px-4 text-[12px]">
        <span class="border-b border-cp-ink py-2 font-[510] text-cp-ink">Active</span>
        <span class="py-2 text-cp-subtle">Closed</span>
        <span class="ml-auto hidden items-center gap-1 text-cp-muted sm:inline-flex">Loan Type <ng-icon name="phosphorCaretDown" size="11" /></span>
        <span class="hidden items-center gap-1 text-cp-muted sm:inline-flex">Status <ng-icon name="phosphorCaretDown" size="11" /></span>
      </div>
      <ul>
        @for (r of requests; track r.ref; let first = $first) {
          <li [class]="'grid grid-cols-[minmax(0,1fr)_auto] items-center gap-x-4 border-b border-cp-line px-4 py-2.5 last:border-b-0 sm:grid-cols-[64px_minmax(0,1fr)_96px_120px] ' + (first ? 'bg-cp-fill' : '')">
            <span class="hidden font-cp-mono text-[12px] text-cp-subtle sm:block">{{ r.ref }}</span>
            <span class="min-w-0">
              <span class="block truncate text-cp-ink">{{ r.client }}</span>
              <span class="block truncate text-[12px] text-cp-subtle">{{ r.loanType }}</span>
            </span>
            <span class="text-right font-cp-mono text-[12px] tabular-nums text-cp-ink">{{ usd(r.amount) }}</span>
            <span class="hidden items-center gap-2 text-cp-muted sm:flex">
              <span [class]="'h-1.5 w-1.5 shrink-0 rounded-full ' + dot(r.status)"></span>
              <span class="truncate">{{ r.status }}</span>
            </span>
          </li>
        }
      </ul>
    </div>

    <!-- Request detail -->
    <div class="hidden border-l border-cp-line lg:block">
      <div class="border-b border-cp-line px-4 py-3">
        <p class="font-cp-mono text-[12px] text-cp-subtle">{{ selected.ref }}</p>
        <p class="mt-0.5 font-[510] text-cp-ink">{{ selected.client }}</p>
        <p class="mt-0.5 truncate text-[12px] text-cp-subtle">{{ selected.loanType }}</p>
      </div>
      <dl class="space-y-2 border-b border-cp-line px-4 py-3">
        <div class="flex justify-between"><dt class="text-cp-subtle">Status</dt><dd class="flex items-center gap-2 text-cp-ink"><span [class]="'h-1.5 w-1.5 rounded-full ' + dot(selected.status)"></span>{{ selected.status }}</dd></div>
        <div class="flex justify-between"><dt class="text-cp-subtle">Amount</dt><dd class="font-cp-mono text-[12px] tabular-nums text-cp-ink">{{ usd(selected.amount) }}</dd></div>
        <div class="flex justify-between"><dt class="text-cp-subtle">Submitted</dt><dd class="text-cp-ink">{{ selected.submitted }}</dd></div>
      </dl>
      <div class="px-4 py-3">
        <p class="text-cp-subtle">Options</p>
        <ul class="mt-2 space-y-1">
          @for (o of options; track o.label) {
            <li class="flex items-center justify-between rounded-md px-2 py-1.5 even:bg-cp-fill">
              <span class="text-cp-muted">{{ o.label }}</span>
              <span class="flex items-center gap-3">
                <span class="font-cp-mono text-[12px] tabular-nums text-cp-ink">{{ o.interestRate }}</span>
                <span class="w-[86px] text-right text-[12px] text-cp-subtle">{{ o.loanTerm }} {{ o.termType }}</span>
              </span>
            </li>
          }
        </ul>
        <p class="mt-4 text-[12px] text-cp-subtle">Lender responded with 3 options</p>
      </div>
    </div>
  </div>
</div>
